import { FOOD_FAULT_RULES_VOCABULARIES } from './food-fault-rules.js';
/** Slice d576 of the catalog (D577): the vocabularies the food fault rules (D576) brought. */
export const SLICE_D576 = [...FOOD_FAULT_RULES_VOCABULARIES];
//# sourceMappingURL=slice-d576.js.map